import React from "react";
import ImageUpload from "../../imageUpload";

interface Props {
    initialImageUrl?: string; // for cases where an image already exists
    readOnlyMode?: boolean; // locks edit operations
    onChangeHandler: (image: File | null) => void;
}

const ImageInput: React.FC<Props> = ({
    initialImageUrl,
    readOnlyMode,
    onChangeHandler,
}) => {
    return (
        <ImageUpload
            initialImgUrl={initialImageUrl || ""}
            readOnly={readOnlyMode}
            onChangeHandler={onChangeHandler}
        />
    );
};

export default ImageInput;
